var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statusName||_vm.getStatusName)?_c('span',{staticClass:"workBench-tag",class:("workBench-type" + _vm.type + "-tag" + (_vm.status||''))},[_vm._v(_vm._s(_vm.statusName?_vm.statusName:_vm.getStatusName))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-965590b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/workBench/components/tag.vue
// module id = null
// module chunks = 